import { render, staticRenderFns } from "./ColumnManagerDialog.vue?vue&type=template&id=4555b690&scoped=true&"
import script from "./ColumnManagerDialog.vue?vue&type=script&lang=js&"
export * from "./ColumnManagerDialog.vue?vue&type=script&lang=js&"
import style0 from "./ColumnManagerDialog.vue?vue&type=style&index=0&id=4555b690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555b690",
  null
  
)

export default component.exports